import { createSlice } from '@reduxjs/toolkit';

import getAllInsuranceModules from '../thunks/getAllInsuranceModules';

import InsuranceModuleInitialState from './InsuranceModuleInitialState';

export const insuranceModuleSlice = createSlice({
  name: 'Common/InsuranceModule',
  initialState: InsuranceModuleInitialState,
  reducers: {
    setInsuranceModules: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllInsuranceModules.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllInsuranceModules.fulfilled, (state, action) => {
        if (action.payload !== undefined) {
          state.loading = false;
          state.data = action.payload;
        }
        return state;
      })
      .addCase(getAllInsuranceModules.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setInsuranceModules } = insuranceModuleSlice.actions;

export default insuranceModuleSlice.reducer;
